/**
 * Block: business-essential
 * V2 JS — Synced image/text Slick sliders
 */

export function init() {
  const block = document.querySelector('.business-essential');
  if (!block) return;

  const $mainSlider = block.querySelector('.business-essential-main-slider');
  const $subSlider = block.querySelector('.business-essential-sub-slider');
  if (!$mainSlider || !$subSlider) return;

  // Slick is loaded globally via legacy bundle — guard before use
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

  const $ = jQuery;

  $($mainSlider).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.business-essential-sub-slider',
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  $($subSlider).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.business-essential-main-slider',
    dots: true,
    dotsClass: 'main-dots',
    appendDots: '.main-dots',
  });

  // Cards slider — mobile only
  const $cardsSlider = block.querySelector('.business-essential-cards-slider');
  if ($cardsSlider) {
    $($cardsSlider).slick({
      slidesToShow: 1.22,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 767,
          settings: 'unslick',
        },
      ],
    });
  }
}
